import { HttpEventType, HttpProgressEvent } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, filter, first, map, shareReplay, takeWhile, tap } from 'rxjs/operators';

import { UploadStatus as FileUploadStatus, UploadStatus } from '@ap/file';
import { ApUploadbeheerResource } from '@ap/interface-apic-uploadbeheer';

import { ApUploadReadFile } from './file-upload.model';

@Injectable()
export class ApFileUploadService {
    private readonly uploadbeheerResource = inject(ApUploadbeheerResource);

    public uploadSingleFile(documentId: string, files: ApUploadReadFile[]): Observable<boolean> {
        const formData = new FormData();
        files.forEach((file) => {
            formData.append('bestanden', file);
            file.status = UploadStatus.UPLOADING;
        });

        const fileUpload = this.uploadbeheerResource.postBestanden(documentId, formData).pipe(shareReplay(1));

        fileUpload
            .pipe(
                takeWhile((event) => event.type !== HttpEventType.Response),
                filter((event) => event.type === HttpEventType.UploadProgress),
                tap((event) => {
                    const uploadProgressEvent = event as HttpProgressEvent;
                    const uploadProgress = (uploadProgressEvent.loaded / uploadProgressEvent.total) * 80;
                    files.forEach((file) => (file.progress = uploadProgress));
                })
            )
            .subscribe();

        return fileUpload.pipe(
            first((d) => d.type === HttpEventType.Response),
            tap(() =>
                files.forEach((file) => {
                    file.status = FileUploadStatus.PROCESSING;
                    file.documentId = documentId;
                })
            ),
            map(() => true),
            catchError(() => {
                files.forEach((file) => (file.status = FileUploadStatus.FAILED));
                return of(false);
            })
        );
    }
}
